var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.139,
    height: 23.328,
    viewBox: "0 0 32.139 23.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 32.138,
    height: 23.328,
    transform: "translate(0 0)",
    fill: "#6b9672"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4373",
    "data-name": "Group 4373",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4340",
    "data-name": "Group 4340",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M22.564,12.887a6.5,6.5,0,1,1-6.495-6.5,6.5,6.5,0,0,1,6.495,6.5m9.574-7.871V20.758a2.569,2.569,0,0,1-2.569,2.569h-27A2.569,2.569,0,0,1,0,20.758V5.016A2.569,2.569,0,0,1,2.569,2.447H9.323l.505-1.023A2.554,2.554,0,0,1,12.119,0h7.9A2.556,2.556,0,0,1,22.31,1.424l.505,1.023h6.754a2.569,2.569,0,0,1,2.569,2.569M6.624,4.6A.623.623,0,0,0,6,3.976H2.995a.622.622,0,0,0-.622.623v.607a.621.621,0,0,0,.622.622H6a.622.622,0,0,0,.623-.622Zm17.847,8.288a8.38,8.38,0,1,0-.661,3.271,8.342,8.342,0,0,0,.661-3.271",
    fill: "#6b9672"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.1c70b965.svg";
export { ForwardRef as ReactComponent };